// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/zeit/3646bbd7/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

